import styled from '@emotion/styled';
import { Button, Modal, Text } from '@innovationdepartment/proxima-ui';
import { HELLO_EMAIL } from 'constants/emails';
import ButtonGroup from 'ui/ButtonGroup';

const Wrapper = styled.div`
  width: 400px;
  margin-bottom: 24px;

  & + * > .proxima-button {
    height: 36px;
  }
`;

const CancelPlanModalContactCS: React.FC<{
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}> = (props) => {
  const { open, onClose } = props;

  return (
    <Modal title="Manage your subscription" open={open}>
      <Wrapper>
        <Text variant="body2" color="neutral80">
          You may cancel your subscription directly through your Shopify Admin by going to{' '}
          <b>Settings &gt; Apps and sales channel settings &gt; Proxima</b> then <b>Uninstall</b>.
          <br />
          <br />
          If you need assistance, please reach out to our customer support team at{' '}
          <a href={`mailto:${HELLO_EMAIL}`}>{HELLO_EMAIL}</a> — we’re here to help!
          <br />
          <br />
        </Text>
      </Wrapper>
      <ButtonGroup>
        <Button
          className="proxima-button"
          variant="contained"
          size="small"
          label="Close"
          onClick={onClose}
        />
      </ButtonGroup>
    </Modal>
  );
};

export default CancelPlanModalContactCS;
